import React from 'react';
import {createSvgIcon} from '../create-svg-icon';

export const SignalCellularConnectedNoInternet1BarIcon = createSvgIcon(
  <React.Fragment>
    <path fillOpacity=".3" d="M22 8V2L2 22h16V8h4z" />
    <path d="M20 10v8h2v-8h-2zm-8 12V12L2 22h10zm8 0h2v-2h-2v2z" />
  </React.Fragment>,
  'SignalCellularConnectedNoInternet1BarOutlined'
);
